module.exports = __webpack_public_path__ + "static/media/r254.cdb246bb.jpg";